import React from 'react';
import { Grid, Table, TableCell, TableBody, TableRow, Popper, Paper, Fade } from '@mui/material';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import { Card, Typography } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { BoldTableHead } from 'components/common/TableStyles';

const StateTransitionsComponent = ({ stateTransitions, stateTransitionReason, onViewReasons, open, anchorEl }) => {
  const { t } = useTranslation();

  return (
    <Card id='StateTransitionsComponent_IconCard' icon={CompareArrowsIcon} title={t('Offer.Edit.StateTransitions.Title')}>
      {' '}
      <Grid container spacing={2}>
        <Table>
          <BoldTableHead>
            <TableRow>
              <TableCell>{t('Offer.Edit.StateTransitions.State')}</TableCell>
              <TableCell>{t('Offer.Edit.StateTransitions.Date')}</TableCell>
              <TableCell>{t('Offer.Edit.StateTransitions.User')}</TableCell>
              <TableCell>{t('Offer.Edit.StateTransitions.Comments')}</TableCell>
              <TableCell>{t('Offer.Edit.StateTransitions.Reasons')}</TableCell>
            </TableRow>
          </BoldTableHead>
          <TableBody>
            {stateTransitions?.stateTransitionData?.states &&
              stateTransitions.stateTransitionData.states.map((state, index) => (
                <TableRow key={index}>
                  <TableCell>{state.stateName}</TableCell>
                  <TableCell>{t('DATE_FORMAT', { date: { value: state.transitionMoment, format: 'DD/MM/YY HH:mm:ss' } })}</TableCell>
                  <TableCell>{state.userName}</TableCell>
                  <TableCell>{state.freeTxt}</TableCell>
                  <TableCell onClick={onViewReasons(state.stateTransitionReasons)}>
                    {state.stateTransitionReasons[0] !== undefined
                      ? state.stateTransitionReasons[0] + (state.stateTransitionReasons.length > 1 ? '...' : '')
                      : ''}{' '}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <Popper open={open} anchorEl={anchorEl} placement='bottom' transition>
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper>
                <Typography>{stateTransitionReason}</Typography>
              </Paper>
            </Fade>
          )}
        </Popper>
      </Grid>
    </Card>
  );
};

StateTransitionsComponent.propTypes = {
  stateTransitions: PropTypes.object,
  onViewReasons: PropTypes.func,
  stateTransitionReason: PropTypes.string,
  open: PropTypes.bool,
  anchorEl: PropTypes.object
};

export default StateTransitionsComponent;
